import { render, staticRenderFns } from "./KeyWord2.vue?vue&type=template&id=1a79d62a&scoped=true"
import script from "./KeyWord2.vue?vue&type=script&lang=js"
export * from "./KeyWord2.vue?vue&type=script&lang=js"
import style0 from "./KeyWord2.vue?vue&type=style&index=0&id=1a79d62a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a79d62a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a79d62a')) {
      api.createRecord('1a79d62a', component.options)
    } else {
      api.reload('1a79d62a', component.options)
    }
    module.hot.accept("./KeyWord2.vue?vue&type=template&id=1a79d62a&scoped=true", function () {
      api.rerender('1a79d62a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/KeyWord2.vue"
export default component.exports